<template>
  <v-card flat class="settings-card">
    <v-container>
      <v-card-title class="settings-header-text">Calendar Settings</v-card-title>
      <v-container>
        <v-form ref="form">
          <v-row>
            <v-col cols="12">
              <v-select
                label="Work Days"
                placeholder="Work Days"
                hint="Days to show on the weekly calendar"
                persistent-hint
                :value="workDaysValue"
                @input="updateConfig('workDays', $event.sort())"
                :items="workDays"
                item-text="label"
                item-value="value"
                multiple
                chips
                class="py-1"
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col cols="12">
              <v-select
                label="Required Appointment Fields"
                placeholder="Required Appointment Fields"
                :value="requiredAppointmentFieldsValue"
                @input="updateConfig('requiredAppointmentFields', $event)"
                :items="appointmentFields"
                item-text="label"
                item-value="value"
                multiple
                chips
                class="py-1"
                dense
                outlined
              ></v-select>
            </v-col>
          </v-row>
          <v-row class="mt-6 mb-10 float-right">
            <v-btn
              color="primary"
              @click="onSave"
              class="mb-2 px-8"
              :disabled="!(settings ? settings.isDirty : false)"
              >Save</v-btn
            >
          </v-row>
        </v-form>
      </v-container>
    </v-container>
  </v-card>
</template>

<script>
import { mask } from "vue-the-mask";
import { CALENDAR_WORKDAY_OPTIONS, CALENDAR_APPOINTMENT_FIELDS } from "../../globalVars";

export default {
  name: "CalendarSettings",
  components: {},
  directives: {
    mask
  },
  data: function() {
    return {
      formValid: true,
      workDaysValue: [],
      requiredAppointmentFieldsValue: []
    };
  },
  async created() {
    await this.$store.dispatch("entities/settings/hydrate", 0);
    const settings = this.$store.getters["entities/settings/query"]().first();
    this.workDaysValue =
      settings &&
      settings.calendarSettings &&
      settings.calendarSettings.workDays
        ? settings.calendarSettings.workDays
        : CALENDAR_WORKDAY_OPTIONS.map(obj => obj.value);
    this.requiredAppointmentFieldsValue =
      settings &&
      settings.calendarSettings &&
      settings.calendarSettings.requiredAppointmentFields
        ? settings.calendarSettings.requiredAppointmentFields
        : CALENDAR_APPOINTMENT_FIELDS.map(obj => obj.value);
  },
  computed: {
    account() {
      return this.$store.getters["entities/accounts/query"]()
        .withAllRecursive(1)
        .first();
    },
    settings() {
      return this.$store.getters["entities/settings/query"]().first();
    },
    formTitle() {
      return this.editedIndex === -1 ? "Add" : "Edit";
    },
    workDays() {
      return CALENDAR_WORKDAY_OPTIONS;
    },
    appointmentFields() {
      return CALENDAR_APPOINTMENT_FIELDS;
    }
  },
  methods: {
    updateConfig(name, value) {
      let vueThis = this;
      let data = {
        isDirty: true,
        calendarSettings:
          this.settings && this.settings.calendarSettings
            ? this.settings.calendarSettings
            : {}
      };
      if (name == "requiredAppointmentFields") {
        data.calendarSettings.requiredAppointmentFields = value;
      } else if (name == "workDays") {
        data.calendarSettings.workDays = value;
      }
      this.$store.dispatch("entities/settings/update", {
        where: vueThis.settings.id,
        data: data
      });
    },
    onSave(evt) {
      evt.preventDefault();
      let vueThis = this;
      this.$store.dispatch(
        "entities/settings/updateSettings",
        vueThis.settings
      );
    }
  },
  watch: {}
};
</script>

<style scoped lang="stylus">
div.spacer {
  width: 3rem;
}
</style>
